(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var $flag = document.getElementById('story-flag');
window.addEventListener('load', function (e) {
  // window.addEventListener('scroll', function(e) {
  //     // if(window.pageYOffset > 290) {
  //     //     if(!$flag.classList.contains('scrolled')) {
  //     //         $flag.classList.toggle('scrolled');
  //     //     }
  //     // } else {
  //     //     if($flag.classList.contains('scrolled')) {
  //     //         $flag.classList.toggle('scrolled');
  //     //     }
  //     // }
  // });
  var handleIntersection = function handleIntersection(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        $flag.classList.add('scrolled');
      } else {// $flag.classList.toggle('scrolled');
      }
    });
  };

  var observer = new IntersectionObserver(handleIntersection);
  observer.observe($flag);
});

},{}]},{},[1]);
